<template>
  <RoamTransactionListTemplate
    :screenConfig="setScreenConfig"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :barcodeScanned="barcodeScanned"
    :formsConfig="formsConfig"
    :setLoading="setLoading"
    :rowClick="rowClickCallBack"
    :persistenceKey="'roam-despatch-order-list'"
  />
</template>

<script>
import RoamTransactionListTemplate from "../../../templates/roam/roam-transaction-list.vue";
import RouteMixin from "@/_mixins/route.mixin";
import { RoamDespatchOrderListService } from "../../../_services/api/roam/roam-despatch-order-list.service";
import { SettingsService } from "@/_services/api/settings/graycorp/settings.service";
export default {
  mixins: [RouteMixin],
  components: {
    RoamTransactionListTemplate,
  },
  data() {
    return {
      despatchScanType: "",
      setLoading: false,
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Sales Orders to Despatch",
        ScreenName: "Sales Orders - To Despatch",
        selectedIndex: 1,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "SalesOrderList",
              select:
                "Code,CodeComputedString,CustomerCode,CustomerName,ShipDate,Status,StopCredit,FriendlyStatus",
              filter: [
                [["Status", "=", "A"], "or", ["Status", "=", "L"]],
                "and",
                ["StopCredit", "=", "N"],
              ],
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "hooray",
                title: "No Orders",
                message:
                  "Your work is complete, all orders have been despatched.",
              },
            },
            options: {
              pageSize: 25,
              allowedPageSizes: [25, 50, 100],
            },
            // rowSelect: {
            //   view: this,
            //   page: "roam-despatch-order",
            //   mode: "edit",
            //   idProperty: "Code",
            // },
          },

          toolbar: {
            search: true,
            columnChooser: false,
            export: false,
            openFilter: false,
            expand: false,
          },
          columns: [
            {
              screenField: "SalesOrder",
              gridDataField: "CodeComputedString",
              dataField: "CodeComputedString",
              calculateSortValue: "Code",
              sortOrder: "asc",
              sortIndex: 0,
              minWidth: 115,
              allowHiding: false,
              // fixed: true,
              // fixedPosition: "left",
            },
            {
              screenField: "Customer",
              filterIndex: 0,
              cssClass: this.isXSmall ? "set-text-overflow" : undefined,
              minWidth: 110,
              // width: 110
            },
            {
              screenField: "ShipDate",
              gridLabel: "Ship Date",
              filterIndex: 3,
              minWidth: 110,
              width: 110,
            },

            {
              screenField: "OrderStatus",
              gridDataField: "FriendlyStatus",
              filterDataField: "FriendlyStatus",
              filterIndex: 4,
              dataSourceConfig: {
                data: ["Active", "Locked"],
              },
              fixed: false,
            },
            // {
            //   screenField: "GridRecordPDFView",
            //   cssClass: "padding-7",
            //   fixed: false,
            // },
            // {
            //   screenField: "GridRecordPrint",
            //   cssClass: "padding-7",
            //   ReferenceNoField: "Code",
            //   fixed: false,
            // },
          ],
        },
      };

      return config;
    },
  },
  methods: {
    async barcodeScanned(barcode) {
      if (barcode) this.setLoading = true;

      var getMatch = barcode.match(/^.{0,2}/g);
      var despatchScanType = undefined;

      if (getMatch.length > 0) {
        if (getMatch[0].toLowerCase() == "so") {
          despatchScanType = "SO";
          barcode = barcode.replace(/^.{0,2}/g, "");
        }
      }

      if (this.despatchScanType == "CONNOTE" && despatchScanType != "SO") {
        this.processConsignmentNo(barcode);
      } else if (this.despatchScanType == "SO" || despatchScanType == "SO") {
        this.processSalesOrderNo(barcode);
      } else {
        this.setLoading = false;
        this.displayGenericAlert("Invalid barcode Scanned!");
      }
    },

    processSalesOrderNo(salesOrderCode) {
      this.$logger.debug(
        "roam picking salesOrderCode scanned:",
        salesOrderCode
      );

      RoamDespatchOrderListService.getByCode(salesOrderCode)
        .then(async (res) => {
          this.setLoading = false;
          this.$logger.debug("getBySalesOrderCode", res);

          if (res.data.value.length > 0) {
            RoamDespatchOrderListService.savePickingSlipStartTime({
              SalesOrderCode: res.data.value[0].SalesOrderCode,
            })
              .then((response) => {
                this.$logger.debug("savePickingSlipStartTime", response);
              })
              .catch((error) => {
                this.$logger.debug("SavePickingSlipStartTime", error);
              });
            this.$router.push({
              path: `/roam-despatch-order/edit/${res.data.value[0].SalesOrderCode}`,
            });
          } else
            this.displayGenericAlert(
              `No Sales Order found for Sales Order Code ${salesOrderCode}`
            );
        })
        .catch((error) => {
          this.setLoading = false;
          this.$logger.debug("Get Sales order by SalesOrderCode", error);
          this.displayGenericAlert("Get Sales order by SalesOrderCode failed!");
        });
    },
    processConsignmentNo(consignmentNo) {
      this.$logger.debug("roam picking consignmentNo scanned:", consignmentNo);

      RoamDespatchOrderListService.getByConsignmentNo(consignmentNo, [
        "ConsignmentNo",
        "Status",
        "SalesOrderCode",
      ])
        .then(async (res) => {
          this.setLoading = false;
          this.$logger.debug("getByConsignmentNo", res);

          if (res.data.value.length > 0) {
            RoamDespatchOrderListService.savePickingSlipStartTime({
              SalesOrderCode: res.data.value[0].SalesOrderCode,
            })
              .then((response) => {
                this.$logger.debug("savePickingSlipStartTime", response);
              })
              .catch((error) => {
                this.$logger.debug("SavePickingSlipStartTime", error);
              });
            this.$router.push({
              path: `/roam-despatch-order/edit/${res.data.value[0].SalesOrderCode}`,
            });
          } else
            this.displayGenericAlert(
              `No Sales Order found for Consignment <br> ${consignmentNo}`
            );
        })
        .catch((error) => {
          this.setLoading = false;
          // eslint-disable-next-line no-console
          this.$logger.debug("Get Sales order by ConsignmentNo", error);
          this.displayGenericAlert("Get Sales order by ConsignmentNo failed!");
        });
    },
    rowClickCallBack(data) {
      if (data.rowType == "data") {
        RoamDespatchOrderListService.savePickingSlipStartTime({
          SalesOrderCode: data.data.Code,
        })
          .then((response) => {
            this.$logger.debug("savePickingSlipStartTime", response);
          })
          .catch((error) => {
            this.$logger.debug("SavePickingSlipStartTime", error);
          });
        this.$router.push({
          path: `/roam-despatch-order/edit/${data.data.Code}`,
        });
      }
    },
  },
  async created() {
    let result = await SettingsService.getBySettingByApplicationFeatureCode(
      "SalesOrderDespatch"
    );

    if (result) {
      let despatchSOScanTypes = result.data.value.filter(
        (x) => x.SettingName == "DespatchSOScanType"
      );

      this.despatchScanType = despatchSOScanTypes[0].SettingValue;
    }
  },
};
</script>
